<template>
    <div class="body-panel">
        <template v-if="sku != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                        </p>
                        <p class="caption-help margin-right-10" v-if="sku.new">Добавление sku</p>
                        <p class="caption-help" v-if="!sku.new">Редактирование sku #{{ sku.Id }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <button type="button" class="btn btn-primary" @click="saveSku()" :disabled="savingInProgress">Сохранить</button>
                        <button type="button" class="btn btn-delete" @click="deleteSku" v-if="!sku.new">Удалить</button>
                    </div>

                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <div class="body-panel" v-if="skuSettings != null">
                    <form action="/sku" class="form-horizontal" novalidate="novalidate" ref="myForm" method="post"
                          enctype="multipart/form-data">
                        <div class="block-in-page">
                            <input type="hidden" :value="sku.Id" name="Id" />

                            <div class="form-field" v-if="skuSettings.Name.ShowInDetails">
                                <label class="input-text-lbl">
                                    Название
                                    <span class="required" aria-required="true"></span>
                                </label>
                                <input name="Name" :class="['input-text', {'input-error': errors.has('Name')}]"
                                       type="text" v-model="sku.Name">
                                <span class="field-validation-valid">{{ errors.first('Name') }}</span>
                            </div>
                            <div class="form-field-group">
                                <div class="form-field" v-if="!sku.new">
                                    <label class="input-text-lbl">
                                        Дата добавления
                                        <span class="required" aria-required="true"></span>
                                    </label>
                                    <div class="input-date-lbl">
                                        <input-date name="CreateDateFormatted" disabled
                                                    v-model="sku.CreateDateFormatted"
                                                    :class="[{'input-error': errors.has('CreateDateFormatted')}]"></input-date>
                                        <span class="field-validation-valid">{{ errors.first('CreateDateFormatted') }}</span>
                                    </div>
                                    <span class="field-validation-valid"></span>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Дата выключения
                                        <span class="required" aria-required="true"></span>
                                    </label>
                                    <div class="input-date-lbl">
                                        <input-date name="EndDateFormatted" v-model="sku.EndDateFormatted"></input-date>
                                    </div>
                                    <span class="field-validation-valid">{{ errors.first('EndDateFormatted') }}</span>
                                </div>
                            </div>
                            <div class="form-field" v-if="domainFolders.length">
                                <label class="input-text-lbl">
                                    Папка
                                </label>
                                <drop-down v-model="sku.DomainFolderId"
                                           :items="domainFolders"
                                           :dataField="'Id'"
                                           :textField="'Name'"></drop-down>
                                <span class="field-validation-valid">{{ errors.first('DomainFolderId') }}</span>
                            </div>
                            <div class="form-field" v-if="skuGroups.length">
                                <label class="input-text-lbl">
                                    Группа
                                </label>
                                <drop-down v-model="sku.GroupId"
                                           :items="skuGroups"
                                           :dataField="'Id'"
                                           :textField="'Name'"></drop-down>
                                <span class="field-validation-valid">{{ errors.first('GroupId') }}</span>
                            </div>
                            <div class="form-field-group" v-if="skuSettings.Volume.ShowInDetails">
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Объем единицы
                                    </label>
                                    <touch-spin v-model="sku.Volume" :decimals="2" :step="0.01"></touch-spin>
                                    <span class="field-validation-valid">{{ errors.first('Volume') }}</span>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Единица измерения
                                    </label>
                                    <input type="text" name="VolumeUnit"
                                           v-model="sku.VolumeUnit"
                                           v-validate="{ rules: { required: this.volumeUnitRequired} }"
                                           :class="['input-text', {'input-error': errors.has('VolumeUnit')}]" />
                                    <span class="field-validation-valid">{{ errors.first('VolumeUnit') }}</span>
                                </div>
                            </div>
                            <div class="form-field-group" v-if="skuSettings.Weight.ShowInDetails">
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Вес нетто
                                    </label>
                                    <touch-spin v-model="sku.Weight" :decimals="2" :step="0.01"></touch-spin>
                                    <span class="field-validation-valid">{{ errors.first('Weight') }}</span>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Вес нетто (единица измерения)
                                    </label>
                                    <input type="text" name="WeightUnit"
                                           v-model="sku.WeightUnit"
                                           v-validate="{ rules: { required: this.weightUnitRequired} }"
                                           :class="['input-text', {'input-error': errors.has('WeightUnit')}]" />
                                    <span class="field-validation-valid">{{ errors.first('WeightUnit') }}</span>
                                </div>
                            </div>

                            <div class="form-field" v-if="skuSettings.Category.ShowInDetails">
                                <label class="input-text-lbl">
                                    Категория
                                </label>
                                <input name="Category" class="input-text" type="text" v-model="sku.Category">
                                <span class="field-validation-valid">{{ errors.first('Category') }}</span>
                            </div>
                            <div class="form-field" v-if="skuSettings.Subcategory.ShowInDetails">
                                <label class="input-text-lbl">
                                    Подкатегория
                                </label>
                                <input name="Subcategory" class="input-text" type="text" v-model="sku.Subcategory">
                                <span class="field-validation-valid">{{ errors.first('Subcategory') }}</span>
                            </div>
                            <div class="form-field" v-if="skuSettings.Brand.ShowInDetails">
                                <label class="input-text-lbl">
                                    Бренд
                                </label>
                                <input name="Brand" class="input-text" type="text" v-model="sku.Brand">
                                <span class="field-validation-valid">{{ errors.first('Brand') }}</span>
                            </div>
                            <div class="form-field" v-if="skuSettings.Code.ShowInDetails">
                                <label class="input-text-lbl">
                                    Код
                                </label>
                                <input name="Code" class="input-text" type="text" v-model="sku.Code">
                                <span class="field-validation-valid">{{ errors.first('Code') }}</span>
                            </div>
                            <div class="form-field" v-if="skuSettings.VendorCode.ShowInDetails">
                                <label class="input-text-lbl">
                                    Артикул
                                </label>
                                <input name="Code" class="input-text" type="text" v-model="sku.VendorCode">
                                <span class="field-validation-valid">{{ errors.first('VendorCode') }}</span>
                            </div>
                            <div class="form-field" v-if="skuSettings.RRC.ShowInDetails">
                                <label class="input-text-lbl">
                                    РРЦ
                                </label>
                                <touch-spin v-model="sku.RRC" :decimals="2" :step="0.01"></touch-spin>
                                <span class="field-validation-valid">{{ errors.first('RRC') }}</span>
                            </div>
                            <div class="form-field" v-if="skuSettings.SkuOrder.ShowInDetails">
                                <label class="input-text-lbl">
                                    Порядковый номер
                                </label>
                                <touch-spin v-model.number="sku.Order"></touch-spin>
                                <span class="field-validation-valid">{{ errors.first('Order') }}</span>
                            </div>
                            <div class="form-field" v-if="skuSettings.ExternalCode.ShowInDetails">
                                <label class="input-text-lbl">
                                    Внешний код
                                </label>
                                <input name="ExternalCode" class="input-text" type="text" v-model="sku.ExternalCode">
                                <span class="field-validation-valid">{{ errors.first('ExternalCode') }}</span>
                            </div>
                            <div class="form-field" v-if="skuSettings.UnitBarCode.ShowInDetails">
                                <label class="input-text-lbl">
                                    Штрихкод единицы
                                </label>
                                <input name="UnitBarCode" class="input-text" type="text" v-model="sku.UnitBarCode">
                                <span class="field-validation-valid">{{ errors.first('UnitBarCode') }}</span>
                            </div>
                            <div class="form-field" v-if="skuSettings.BoxBarCode.ShowInDetails">
                                <label class="input-text-lbl">
                                    Штрихкод коробки
                                </label>
                                <input name="BoxBarCode" class="input-text" type="text" v-model="sku.BoxBarCode">
                                <span class="field-validation-valid">{{ errors.first('BoxBarCode') }}</span>
                            </div>
                            <div class="form-field" v-if="skuSettings.Amount.ShowInDetails">
                                <label class="input-text-lbl">
                                    Количество штук в коробке
                                </label>
                                <touch-spin v-model.number="sku.Amount"></touch-spin>
                                <span class="field-validation-valid">{{ errors.first('Amount') }}</span>
                            </div>

                            <div class="margin-top-10" v-if="skuSettings.Description.ShowInDetails">
                                <div class="form-group">
                                    <label class="input-text-lbl">
                                        Описание
                                        <span class="required" aria-required="true"></span>
                                    </label>
                                    <froala-editor ref="Description" name="Description"
                                                   :class="[{'input-error': errors.has('Description')}]"
                                                   v-validate="'required'"
                                                   v-model="sku.Description"
                                                   :imageUploadURL="config.apiUrl + '/api/sku/uploadFiles?fileType=Image&skuId=' + sku.Id + '&projectId=' + projectId">
                                    </froala-editor>
                                    <span class="field-validation-valid">{{ errors.first('Description') }}</span>
                                </div>
                            </div>

                            <div class="form-field" v-for="s of skuCustomSettingsOrdered" v-if="s.ShowInDetails">
                                <label class="input-text-lbl">
                                    {{s.Title}}
                                </label>
                                <input :name="s.FieldName" class="input-text" type="text" v-model="sku[s.FieldName]">
                                <span class="field-validation-valid">{{ errors.first(s.FieldName) }}</span>
                            </div>
                        </div>
                        <div class="block-in-page">
                            <h2>Настройка связи с торговыми точками</h2>

                            <div class="flex" v-if="tpLinksExist && linkingEnabled">
                                <div class="profile-roles">
                                    <div class="draggable-item" v-for="(skuLink, i) of sku.Links" @dblclick="onLinkEdit(skuLink)" @click="onLinkSelect(skuLink)">
                                        <template v-if="skuLink.Edited">
                                            <div class="form-field-group">
                                                <div class="form-field">
                                                    <search-filter :name="'skuLinkName' + i"
                                                                   v-validate="{ rules: { required: true} }"
                                                                   :hasErrors="errors.has('skuLinkName' + i)"
                                                                   :extra="i"
                                                                   :placeholder="'Выберите связь'"
                                                                   :searchFunction="searchSkuLinkFunction"
                                                                   :selectedItem="{Id: skuLink.Name, Name: skuLink.Name}"
                                                                   :searchOnSelect="true"
                                                                   :scrollable="true"
                                                                   @onFilterChange="onChangeSkuLinkSearch(...arguments, skuLink)"></search-filter>
                                                </div>
                                                <div class="form-field">
                                                    <touch-spin :name="'skuLinkAmount' + i"
                                                                v-validate="{required: true}"
                                                                :cssclass="['input-text', {'input-error': errors.has('skuLinkAmount' + i)}]"
                                                                v-model="skuLink.Amount" :decimals="2" :step="0.01"
                                                                @click.stop=""
                                                                @keyup.enter.stop="onLinkEditOk(skuLink)"></touch-spin>
                                                </div>
                                                <div class="form-field">
                                                    <div class="btns flex" style="float:right;">
                                                        <button type="button" class="btn" @click.stop="onLinkEditOk(skuLink)">Ok</button>
                                                        <button type="button" class="btn" @click.stop="onLinkEditCancel(skuLink)">Отмена</button>
                                                    </div>
                                                </div>

                                            </div>
                                        </template>
                                        <template v-if="!skuLink.Edited">
                                            {{ skuLink.Name }} - {{ skuLink.Amount }}{{bonusTypeStr}}
                                            <div class="btns flex" style="float:right;margin-top:-6px">
                                                <button type="button" class="btn" @click.stop="onLinkEdit(skuLink)">Редактировать</button>
                                                <button type="button" class="btn btn-delete" @click.stop="removeLink(skuLink, i)">Удалить</button>
                                            </div>
                                        </template>
                                    </div>
                                    <button type="button" class="btn margin-top-10" @click.stop="addNewLink">Добавить</button>
                                    <button type="button" class="btn margin-top-10" @click.stop="openSkuSearchModal()" v-if="sku.Links && sku.Links.length">
                                        Применить значения к другим SKU
                                    </button>
                                </div>
                                <div class="profile-setting">
                                    <template v-if="linkSelected">
                                        <p class="panel-block-header">Связь "{{ linkSelected.Name }}"</p>
                                        <p class="caption-help">Настройка периодов</p>
                                        <div class="draggable-item" v-for="(period, j) of linkSelected.Periods" @dblclick="onPeriodEdit(period)">
                                            <template v-if="period.Edited">
                                                <div class="form-field-group">
                                                    <div class="form-field">
                                                        <div class="input-date-lbl">
                                                            <input-date :name="'DateStartFormatted' + j" placeholder="Начало периода"
                                                                        v-model="period.DateStartFormatted"
                                                                        v-validate="{required: true}"
                                                                        :class="[{'input-error': errors.has('DateStartFormatted' + j)}]"
                                                                        @input="onChangeDate(period, 'DateStartFormatted', 'DateStart')"></input-date>
                                                        </div>
                                                    </div>
                                                    <div class="form-field">
                                                        <div class="input-date-lbl">
                                                            <input-date :name="'DateEndFormatted' + j" placeholder="Завершение периода"
                                                                        v-model="period.DateEndFormatted"
                                                                        :class="[{'input-error': errors.has('DateEndFormatted' + j)}]"
                                                                        @input="onChangeDate(period, 'DateEndFormatted', 'DateEnd')"></input-date>
                                                        </div>
                                                    </div>
                                                    <div class="form-field">
                                                        <touch-spin :name="'skuPeriodAmount' + j"
                                                                    v-validate="{required: true}"
                                                                    :cssclass="['input-text', {'input-error': errors.has('skuPeriodAmount' + j)}]"
                                                                    v-model="period.Amount" :decimals="2" :step="0.01" @click.stop=""></touch-spin>
                                                    </div>
                                                    <div class="form-field">
                                                        <div class="btns flex" style="float:right;">
                                                            <button type="button" class="btn" @click.stop="onPeriodEditCancel(period)">Ok</button>
                                                        </div>
                                                    </div>

                                                </div>
                                            </template>
                                            <template v-if="!period.Edited">
                                                с {{ period.DateStartFormatted }}
                                                <template v-if="period.DateEndFormatted ">
                                                    по {{ period.DateEndFormatted }}
                                                </template> - {{ period.Amount }}{{bonusTypeStr}}
                                                <div class="btns flex" style="float:right;margin-top:-6px">
                                                    <button type="button" class="btn" @click.stop="onPeriodEdit(period)">Редактировать</button>
                                                    <button type="button" class="btn btn-delete" @click.stop="removePeriod(period, j)">Удалить</button>
                                                </div>
                                            </template>
                                        </div>
                                        <button type="button" class="btn margin-top-10" @click.stop="addNewPeriod">Добавить</button>
                                    </template>
                                    <template v-if="!linkSelected && sku.Links && sku.Links.length">
                                        <p class="caption-help">Выберите связь с торговой точкой</p>
                                    </template>
                                </div>
                            </div>
                            <div class="error" v-if="!tpLinksExist">
                                В торговых точках нет ни одного значения в Поле для связи
                            </div>
                        </div>

                        <div class="block-in-page">
                            <div class="flex">
                                <image-setting :img="imgSite" :name="'site'" :parentImage="true" @onImageViewChanged="onImageViewChanged"></image-setting>
                                <div class="form-field" style="width:300px;min-width:300px;margin-left:20px">
                                    <div class="panel-block panel-block-new" v-if="skuSettings != null" style="margin-right:0">
                                        <div class="panel-block-img-base">
                                            <div class="panel-block-img">
                                                <img :src="imgSitePath" alt="" :style="imageStyleFormatted" v-if="imgSitePath" />
                                            </div>
                                        </div>
                                        <div class="panel-block-info">
                                            <p class="panel-block-header margin-bottom-10" v-if="skuSettings.Name.ShowInList">{{ sku.Name }}</p>
                                            <p class="input-text-lbl" v-if="skuSettings.Brand.ShowInList"><i>Бренд:  </i>{{ sku.Brand }}</p>
                                            <p class="input-text-lbl" v-if="skuSettings.Category.ShowInList"><i>Категория:  </i>{{ sku.Category }}</p>
                                            <p class="input-text-lbl" v-if="skuSettings.Subcategory.ShowInList"><i>Подкатегория:  </i>{{ sku.Subcategory }}</p>
                                            <p class="panel-body-desc" v-if="skuSettings.Description.ShowInList" v-html="sku.DescriptionFormatted"></p>
                                        </div>
                                        <div class="panel-body-actions">
                                            <button class="btn">Подробнее</button>
                                            <span class="panel-body-actions-date">{{ sku.CreateDate | date-short }}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="block-in-page">
                            <div class="flex">
                                <image-setting :img="imgMobile" :parentImgPath="imgSitePath" :name="'mobile'" @onImageViewChanged="onImageViewChanged"></image-setting>
                                <div class="form-field" style="width:500px;min-width:500px;margin-left:20px">
                                    <div class="panel-block panel-block-new panel-block-mobile" v-if="skuSettings != null" style="margin-right:0">
                                        <div class="flex">
                                            <div class="panel-block-img panel-block-img-mobile">
                                                <img :src="imgMobilePath" alt="" :style="imageStyleMobileFormatted" v-if="imgMobilePath" />
                                            </div>
                                            <div class="panel-block-info">
                                                <p class="panel-block-header margin-bottom-10" v-if="skuSettings.Name.ShowInList">{{ sku.Name }}</p>
                                            </div>
                                        </div>
                                        <div class="panel-body-actions">
                                            <button class="btn">Подробнее</button>
                                            <span class="panel-body-actions-date">{{ sku.CreateDate | date-short }}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </template>

        <popup-window ref="ppSkuList" :title="'Применение текущей настройки связей к sku'" :width="800">
            <p class="caption-help"></p>
            <input type="text" class="input-text" placeholder="Поиск sku" v-model="skuSearch.value" @input="onSearchChange" @click="onSearchChange"/>
            <!--<div class="line-separator"></div>-->
            <table class="table-view margin-top-10" id="tSkuFieldSett">
                <thead class="head-show">
                <tr class="heading">
                    <th>Наименование</th>
                    <th>Действие</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) of skuSearch.list">
                        <td>{{item.Name}}</td>
                        <td>
                            <input :id="'itemSelected' + i" value="true"
                                   type="checkbox" class="input-checkbox"
                                   v-model="item.Selected"/>
                            <label :for="'itemSelected' + i" class="input-checkbox-lbl">Выбрать</label>
                        </td>
                    </tr>
                    <tr v-if="!skuSearch.list.length">
                        <td colspan="2">
                            Нет данных
                        </td>
                    </tr>
                </tbody>
            </table>

            <button type="button" class="btn btn-primary margin-top-10" @click="skuSearchApply()" v-if="skuSearch.list.length">Применить</button>
        </popup-window>

        <vue-headful title="SKU" />
    </div>
</template>

<script>
    import BackendApi from '../../backendApi'
    import $ from 'jquery'
    import UI from '../../helpers/ui-helpers'
    import moment from 'moment'
    import projectMixin from '../../helpers/project-mixin'
    import _ from 'lodash'
    import config from '../../config'

    let backendApi = new BackendApi();

    let ImageStyleDefault = {
        top: 0,
        left: 100,
        translateY: 0,
        translateX: -50,
        size: 100,
        resizeType: 1
    };

    export default {
        name: "sku-edit",

        mixins: [projectMixin], // projectId

        data() {
            return {
                sku: null,
                skuSettings: null,
                file: null,
                deleteImage: false,
                reportDateRequired: false,
                skuSearch: {
                    list: [],
                    page: 1,
                    rowsPerPage: 20,
                    canBeLoaded: true,
                    value: null
                },
                ReportSettings: null,
                tpLinksExist: null,
                tpLinksEmptyExist: null,
                domainFolders: [{
                    Id: '',
                    Name: 'Выбрать'
                }],
                skuGroups: [{
                    Id: '',
                    Name: 'Без категории'
                }],
                bonusTypeStr: 'руб',
                imgSitePath: null,
                imgSite: {},
                imgMobilePath: null,
                imgMobile: {},
                savingInProgress: false,
                config
            }
        },

        computed:{
            skuCustomSettingsOrdered(){
                if(this.skuSettings == null){
                    return null;
                }

                return _.orderBy(Object.values(this.skuSettings).filter(x => x.FieldName.startsWith('CustomField')), 'SettingsOrder');
            },

            imageStyleFormatted() {
                let settings = {
                    left: this.imgSite.ImageStyle.left + '%',
                    top: this.imgSite.ImageStyle.top + '%',
                    transform: 'translateY(' + this.imgSite.ImageStyle.translateY + '%) translateX(' +
                        this.imgSite.ImageStyle.translateX + '%)'
                };
                if (this.imgSite.ImageStyle.resizeType === 1 && parseInt(this.imgSite.ImageStyle.size)) {
                    settings.height = this.imgSite.ImageStyle.size + '%';
                }
                if (this.imgSite.ImageStyle.resizeType === 2 && parseInt(this.imgSite.ImageStyle.size)) {
                    settings.width = this.imgSite.ImageStyle.size + '%';
                }

                return settings;
            },

            imageStyleMobileFormatted() {
                let settings = {
                    left: this.imgMobile.ImageStyle.left + '%',
                    top: this.imgMobile.ImageStyle.top + '%',
                    transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' +
                        this.imgMobile.ImageStyle.translateX + '%)'
                };
                if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.height = this.imgMobile.ImageStyle.size + '%';
                }
                if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.width = this.imgMobile.ImageStyle.size + '%';
                }

                return settings;
            },

            linkSelected: function () {
                let selected =  this.sku.Links.filter((r) => r.Selected);
                return selected.length ? selected[0]: null;
            },

            linkingEnabled(){
                if(this.ReportSettings) {
                    return this.ReportSettings.filter(x => {
                        return x.type === 'sku' && !x.deleted;
                    }).length > 0;
                }
                else{
                    return false;
                }
            },

            volumeUnitRequired(){
                return this.sku.Volume ? true: false;
            },

            weightUnitRequired(){
                return this.sku.Weight ? true: false;
            }
        },

        methods: {

            searchSkuLinkFunction(searchText, callback, extra, page) {
                let vm = this;
                let skuLink = null;
                for(let i = 0; i < this.sku.Links.length; i++){
                    if(i === extra){
                        skuLink = this.sku.Links[i];
                        break;
                    }
                }
                let linksExcepted = vm.sku.Links
                    .filter(x => skuLink === null || skuLink.Name !== x.Name)
                    .map(x => x.Name);
                // console.info('skuLink', skuLink ? skuLink.Name : 'nil');

                vm.callApiWrapper(backendApi.skuLinksSearch((page - 1) * 20, 20, vm.projectId, searchText, linksExcepted))
                    .then(function (resp) {
                        callback(resp.data);
                    })
            },

            onChangeSkuLinkSearch(listItem, extra, skuLink) {
                if(listItem)
                {
                    skuLink.Name = listItem.Name;
                }
                else{
                }
            },

            onSearchChange: _.debounce(function () {

                this.searchSku();

            }, 1000),

            openSkuSearchModal() {
                let vm = this;

                vm.$refs.ppSkuList.show();
                
                vm.$nextTick(() => {
                    vm.onSearchChange();
                });
            },

            searchSku(){
                let vm = this;
                let searchVal = this.skuSearch.value;

                this.callApiWrapper(backendApi.skuList((this.skuSearch.page - 1) * this.skuSearch.rowsPerPage, this.skuSearch.rowsPerPage, vm.projectId, searchVal, true))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки SKU');
                        }
                        else {
                            vm.skuSearch.list = [];

                            if (resp.data && resp.data.length) {
                                for (let item of resp.data) {
                                    item.Selected = false;
                                }
                                vm.skuSearch.list.push(...resp.data);
                            }
                            else {
                                vm.skuSearch.canBeLoaded = false;
                            }
                        }
                    });
            },

            skuSearchApply() {
                let vm = this;
                if (vm.skuSearch.list.length) {
                    let selectedIds = vm.skuSearch.list.filter((x) => x.Selected).map(x => {
                        return {
                            Id: x.Id, IsFolder: x.IsFolder
                        }
                    });
                    if (!selectedIds.length) {
                        alert('Ничего не выбрано!')
                        return;
                    }

                    this.callApiWrapper(backendApi.skuApplyLinks(this.$route.params.id, selectedIds, vm.sku.Links))
                        .then(function (resp) {
                            if (resp.hasError && resp.status !== 401) {
                                UI.toastr.error('Ошибка во время выполнения операции');
                            }
                            else {
                                UI.toastr.success('Успешно применено');
                                vm.$refs.ppSkuList.close();

                                UI.blockUI('.page-content', 'Загрузка...');
                                vm.loadSku().then(() => {
                                    UI.unblockUI('.page-content');
                                });
                            }
                        });
                }
            },

            onChangeDate(item, formatted, raw) {
                item[raw] = moment(item[formatted], 'DD.MM.YYYY').format();
            },

            back() {
                this.$router.back();
            },

            onLinkSelect(link){
                this.sku.Links.forEach((r) => {
                    r.Selected = false;
                });
                link.Selected = true;
            },

            onLinkEdit(link){
                let vm = this;
                this.formIsValid().then((res) => {
                    if (res) {
                        for(let x of vm.sku.Links){
                            x.Edited = false;
                        }
                        link.Edited = true;

                        link.OriginName = link.Name;
                        link.OriginAmount = link.Amount;
                    }
                });
            },

            onLinkEditOk(link){
                this.formIsValid().then((res) => {
                    if (res) {
                        link.Edited = false;
                    }
                });
            },

            onLinkEditCancel(link){
                link.Name = link.OriginName;
                link.Amount = link.OriginAmount;
                link.Edited = false;
            },

            removeLink(skuLink, i){
                this.sku.Links.splice(i, 1);
            },

            addNewLink() {
                let vm = this;
                this.formIsValid().then((res) => {
                    if (res) {
                        let link = {
                            Id: 0,
                            Name: null,
                            Amount: 0,
                            Edited: false,
                            Selected: false,
                            OriginName: null,
                            OriginAmount: 0,
                            Periods: []
                        };
                        vm.sku.Links.push(link);
                        vm.onLinkSelect(link);
                        vm.onLinkEdit(link);
                    }
                });

            },

            onPeriodEdit(item){
                let vm = this;

                this.formIsValid().then((res) => {
                    if (res) {
                        for(let x of vm.linkSelected.Periods){
                            x.Edited = false;
                        }
                        item.Edited = true;
                        vm.linkSelected.Periods.__ob__.dep.notify();
                    }
                });
            },

            onPeriodEditCancel(item){
                let vm = this;

                this.formIsValid().then((res) => {
                    if (res) {
                        item.Edited = false;
                        vm.linkSelected.Periods.__ob__.dep.notify();
                    }
                });
            },

            removePeriod(item, j){
                this.linkSelected.Periods.splice(j, 1);
            },

            addNewPeriod() {
                let vm=this;
                // отлючил проверку - если настройка “Указывать дату отчета” не включена, то в качестве даты отчёта берём дату заполнения
                /*if(!vm.reportDateRequired){
                    alert('Необходимо наличие настройки “Указывать дату отчета” в проекте');
                    return;
                }*/

                this.formIsValid().then((res) => {
                    if (res) {
                        let item = {
                            Id: 0,
                            Amount: 0
                        };
                        vm.linkSelected.Periods.push(item);
                        vm.onPeriodEdit(item);
                    }
                });
            },

            formIsValid() {
                return this.$validator.validate().then(result => {
                    return result;
                });
            },

            loadSku() {
                let vm = this;
                let id = parseInt(this.$route.params.id);

                    return backendApi.skuLoad(id, vm.projectId, true).then(function (response) {
                        console.info('project.edit -> load, response:', response.data);
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при загрузке SKU');
                        }
                        else {
                            if (id === 0) {
                                vm.sku = {
                                    Id: 0,
                                    new: true,
                                    ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                                    Links:[],
                                    GroupId: null,
                                    VolumeUnit: 'л',
                                    WeightUnit: 'кг',
                                    ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                                    ImageMobile: {}
                                };
                                vm.imgSite = {
                                    ImageStyle: vm.sku.ImageStyle,
                                    ImagePath: null,
                                    Image: {}
                                };
                                vm.imgMobile = {
                                    ImageStyle: vm.sku.ImageStyleMobile,
                                    ImagePath: null,
                                    Image: {}
                                };
                            }
                            else {
                                if (response.data.sku == null) {
                                    vm.$router.back();
                                }
                                if (response.data.sku.ImageStyle) {
                                    response.data.sku.ImageStyle = JSON.parse(response.data.sku.ImageStyle);
                                } else {
                                    response.data.sku.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                                }
                                if (response.data.sku.ImageStyleMobile) {
                                    response.data.sku.ImageStyleMobile = JSON.parse(response.data.sku.ImageStyleMobile);
                                } else {
                                    response.data.sku.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                                }

                                response.data.sku.Links.forEach((r) => {
                                    r.Edited = false;
                                    r.Selected = false;

                                    r.Periods.forEach((p) => {
                                        p.Edited = false;
                                        p.DateStartFormatted = vm.formatDate(p.DateStart);
                                        p.DateEndFormatted = vm.formatDate(p.DateEnd);
                                    });
                                });
                                response.data.sku.GroupId = response.data.sku.Group ? response.data.sku.Group.Id : null;

                                vm.sku = response.data.sku;
                                vm.sku.CreateDateFormatted = vm.formatDate(vm.sku.CreateDate);
                                if (vm.sku.EndDate) {
                                    vm.sku.EndDateFormatted = vm.formatDate(vm.sku.EndDate);
                                }
                                vm.sku.ImageMobile = {};
                                vm.imgMobile = {
                                    ImageStyle: vm.sku.ImageStyleMobile,
                                    ImagePath: vm.sku.ImageMobilePath,
                                    Image: {}
                                };
                                delete vm.sku.ImageStyle.useMainPhoto;
                                vm.imgSite = {
                                    ImageStyle: vm.sku.ImageStyle,
                                    ImagePath: vm.sku.Image,
                                    Image: {}
                                };
                            }

                            vm.tpLinksExist = response.data.tpLinksExist;
                            vm.tpLinksEmptyExist = response.data.tpLinksEmptyExist;
                        }
                    })
            },

            loadSettings(){
                let vm = this;
                return this.callApiWrapper(backendApi.skuSettings(vm.projectId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки настроек sku');
                        }
                        else {
                            if (resp.data) {
                                let dict = {};
                                for(let s of resp.data){
                                    if(!dict[s.FieldName]){
                                        dict[s.FieldName] = s;
                                    }
                                }
                                vm.skuSettings = dict;
                            }
                        }
                    })
            },

            loadProject(){
                let vm = this;
                return backendApi.projectLoad(vm.projectId).then(function (response) {
                    let rsData = JSON.parse(response.data.ReportSettings || '[]');
                    for (let item of rsData) {
                        if (typeof item.deleted === 'undefined') {
                            item.deleted = false;
                        }
                    }
                    let bsData = JSON.parse(response.data.BonusSettings || '{"bonusStrategy":{}}');

                    vm.ReportSettings = rsData;
                    vm.reportDateRequired = response.data.ReportDateRequired;

                    if (bsData.bonusStrategy.type === 'sku' && bsData.bonusStrategy.data.bonusType === 'percent') vm.bonusTypeStr = "%";
                    else vm.bonusTypeStr = "руб";
                });
            },

            loadFolders(){
                let vm = this;
                return backendApi.domainFoldersList(vm.projectId, 1).then(function (response) {
                    vm.domainFolders.push(...response.data);
                });
            },

            loadGroups(){
                let vm = this;
                return backendApi.skuGroupList(vm.projectId).then(function (response) {
                    vm.skuGroups.push(...response.data);
                });
            },

            saveSku() {
                let vm = this;

                this.$validator.validate().then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        if (vm.savingInProgress) {
                            return;
                        }
                        vm.savingInProgress = true;
                        UI.blockUI('.portlet', 'Сохранение...');

                        let selectedProjectId = localStorage.getItem('selectedProjectId');

                        let saveObj = Object.assign({}, vm.sku, {
                            //CreateDate: moment(vm.sku.CreateDateFormatted, 'DD.MM.YYYY').format(),
                            EndDate: moment(vm.sku.EndDateFormatted, 'DD.MM.YYYY').format(),
                            DeleteImage: vm.imgSite.Image.Id === -1,
                            ProjectId: selectedProjectId != null ? parseInt(selectedProjectId) : null
                        });
                        saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                        saveObj.FileData = vm.imgSite.Image.FileData;
                        saveObj.FileName = vm.imgSite.Image.FileName;
                        saveObj.ImageMobile = vm.imgMobile.Image;
                        if (vm.imgMobile.ImageStyle.useMainPhoto) {
                            saveObj.ImageMobile.FileName = '';
                            saveObj.ImageMobile.FileData = '';
                            saveObj.ImageMobile.Id = -1;
                            saveObj.ImageMobilePath = '';
                        }
                        saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);

                        this.callApiWrapper(backendApi.skuSave(saveObj)).then(function (response) {
                            UI.unblockUI('.portlet');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при сохранении SKU');
                            } else {
                                UI.toastr.success('Успешно сохранено');
                                vm.$router.push('/sku/' + response.data + '/?saved');
                            }
                            vm.savingInProgress = false;
                        });
                    }
                });
            },

            deleteSku(){
                let that = this;

                if (confirm('Вы уверены?')) {
                    UI.blockUI('.portlet', 'Удаление...');
                    backendApi.skuDelete(that.sku.Id).then(function (response) {
                        UI.unblockUI('.portlet');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении SKU');
                        } else {
                            UI.toastr.success('Успешно удалено');
                            that.$router.push('/sku');
                        }
                    });
                }
            },

            onImageViewChanged(imgPath, name) {
                if (name === 'site')
                    this.imgSitePath = imgPath;
                else
                    this.imgMobilePath = imgPath;
            }
        },


        mounted() {
            let vm = this;
            UI.blockUI('.page-content', 'Загрузка...');

            Promise.all([this.loadSettings(), this.loadProject(), this.loadFolders(), this.loadGroups()]).then(() => {
                this.loadSku();

                UI.unblockUI('.page-content');

            });
        },

        destroyed(){
            
        }
    }
</script>

<style scoped>
    .draggable-item{
        cursor: default;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/SkuEdit.vue